import React from 'react';
import classNames from 'classnames';
import styles from './TooltipPremiumPlan.module.scss';
import lightningImg from '../../../assets/images/lightning.png';
import lightningImg2x from '../../../assets/images/lightning@2x.png';
import { renderTextWithIndexedTags } from '../../../utilities/helpers/phrases';
import { Phrases } from '../../../utilities/constants/phrases';
import Tooltip, { Props as TooltipProps } from '../Tooltip';
import Title from '../../TitleWithGradient/TitleWithGradient';

interface Props extends Omit<TooltipProps, 'title'> {}

const TooltipPremiumPlan: React.FC<Props> = (props) => (
  <Tooltip
    {...props}
    title={
      <div className={styles.tooltipPremiumPlan}>
        <Title
          title={renderTextWithIndexedTags(Phrases.TOOLTIP_PREMIUM_PLAN_TITLE, [
            <span key='span-0' />,
          ])}
          className='text-lg fw-bold c-white'
        />
        <p className={classNames(styles.subtitle, 'text-sm')}>
          {Phrases.TOOLTIP_PREMIUM_PLAN_SUBTITLE}
        </p>
        <img
          className={styles.img}
          src={lightningImg}
          alt=''
          srcSet={`${lightningImg2x} 2x`}
        />
      </div>
    }
  />
);

export default TooltipPremiumPlan;
